import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../service/common";
import { FileUpload } from "../service/file-upload";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";
import { API } from "../config/api-config";
// import * as moment from "moment";
import * as moment from "moment";
import * as _ from "lodash";

declare var $: any;
@Component({
  selector: "app-latest-activity-edit",
  templateUrl: "./latest-activity-edit.component.html",
  styleUrls: ["./latest-activity-edit.component.css"],
})
export class LatestActivityEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  public data: any = {
    active: 1,
    contentEn: "",
    contentTc: "",
    contentEnUrl: "",
    contentTcUrl: "",
    days: 0,
    detailImageEn: "",
    detailImageTc: "",
    endTime: "",
    id: 0,
    imageEn: "",
    imageTc: "",
    productId: null,
    publishTime: "",
    startTime: "",
    titleEn: "",
    titleTc: "",
    type: "COMMON",
    contentType: 0,
    mediaType1: 0,
    mediaType2: 0,
    mediaEn1: "",
    mediaEn2: "",
    mediaTc1: "",
    mediaTc2: "",
    activityType:''
  };
  public id: number = 0;
  public isCreate: boolean = false;
  public imagePath: string = "";

  public selectLoading = false;

  public productList = [];

  private productPage = 0;

  public searchText = "";

  ngOnInit() {
    this.getPath();
    this.initTime();
    this.getProduct();
    this.getLatestActivityType();
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });

    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }

    this.initTime();
  }

  public showImageEn: boolean = false;
  public showImageTc: boolean = false;
  public showMediaEn1: boolean = false;
  public showMediaTc1: boolean = false;
  public showMediaTc2: boolean = false;
  public showMediaEn2: boolean = false;
  public showDetailImageTc: boolean = false;
  public showDetailImageEn: boolean = false;
  public tempPath: string = API.getTemp;
  public activityTypeList:Array<any>
  public upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showImageEn = true;
            break;
          case "imageTc":
            self.showImageTc = true;
            break;
          case "detailImageEn":
            self.showDetailImageEn = true;
            break;
          case "detailImageTc":
            self.showDetailImageTc = true;
            break;
          case "mediaEn1":
            self.showMediaEn1 = true;
            break;
          case "mediaTc1":
            self.showMediaTc1 = true;
          case "mediaEn2":
            self.showMediaEn2 = true;
            break;
          case "mediaTc2":
            self.showMediaTc2 = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      }
    });
  }

  public submit(): void {
    let data = this.data;

    data.startTime = moment(data.startTime).utcOffset(8).format();
    data.endTime = moment(data.endTime).utcOffset(8).format();
    data.publishTime = moment(data.publishTime).utcOffset(8).format();
    if (data.type == "COMMON" && data.contentType == 1) {
      data.contentTc = data.contentTcUrl;
      data.contentEn = data.contentEnUrl;
    }
    console.log(data);
    delete data.contentTcUrl;
    delete data.contentEnUrl;
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.latestActivityEdit, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private initTime() {
    let self = this;
    setTimeout((res) => {
      $("#startTime")
        .datetimepicker({
          language: "zh-CN",
          format: "yyyy-mm-dd hh:ii",
          todayBtn: 1,
          autoclose: true,
          startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
        })
        .on("changeDate", function (ev) {
          $("#endTime").datetimepicker("setStartDate", $("#startTime").val());
          self.data.startTime = $(this).val();
        });

      $("#endTime")
        .datetimepicker({
          language: "zh-CN",
          format: "yyyy-mm-dd hh:ii",
          todayBtn: 1,
          autoclose: true,
          startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
        })
        .on("changeDate", function (ev) {
          $("#startTime").datetimepicker("setEndDate", $("#endTime").val());
          self.data.endTime = $(this).val();
        });
      $("#publishTime")
        .datetimepicker({
          language: "zh-CN",
          format: "yyyy-mm-dd hh:ii",
          todayBtn: 1,
          autoclose: true,
          startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
        })
        .on("changeDate", function (ev) {
          // $("#publishTime").datetimepicker(
          //   "setpublishTime",
          //   $("#publishTime").val()
          // );
          self.data.publishTime = $(this).val();
        });
    });
  }

  public getProduct() {
    if (this.selectLoading) {
      return;
    }
    this.selectLoading = true;
    this.HttpService.getData(API.product, {
      pageNumber: this.productPage,
      name: this.searchText,
    })
      .then((response) => {
        this.productList = _.uniqWith(
          [...this.productList, ...response.data.content],
          _.isEqual
        );
        this.selectLoading = false;
        this.productPage++;
      })
      .catch((error) => {
        this.selectLoading = false;
      });
  }

  public productSearch = () => {
    console.log();
    this.productPage = 0;

    if (!this.selectLoading) {
      this.productList = [];
      this.getProduct();
    }
  };

  public resetSearch() {
    this.productList = [];
    this.productPage = 0;
    this.getProduct();
  }

  private getData() {
    this.HttpService.getData(API.latestActivity + "/" + this.id).then(
      (response) => {
        let data = response.data;
        if (data.type == "COMMON" && data.contentType == 1) {
          data["contentTcUrl"] = data.contentTc;
          data["contentEnUrl"] = data.contentEn;
        }
        this.data = data;
        this.getProductData(response.data.productId);
      }
    );
  }

  private getLatestActivityType() {
    this.HttpService.getData(API.getLatestActivityType).then(
      (response) => {
        this.activityTypeList = response.data
      }
    );
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(res.data);
    });
  }

  private getProductData(id) {
    this.HttpService.getData(API.product + "/" + id).then((res) => {
      this.productList = _.uniqWith([res.data, ...this.productList], _.isEqual);
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/latest-activity-edit/latest-activity-edit.component.ts